import script from "./modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal.vue?vue&type=script&setup=true&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=388c34df&lang=scss"

const __exports__ = script;

export default __exports__